<template>
  <el-input v-model="textareaValue" v-bind="configs" class="lc-textarea" type="textarea" />
</template>

<script>
export default {
  name: 'LcTextarea',
  props: {
    configs: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textareaValue:''
    };
  },
  watch: {
    textareaValue(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    this.textareaValue = this.value;
    this.$nextTick(() => {
        let textareaDoms = document
          .getElementsByClassName("el-textarea__inner")
        for(let i=0;i<textareaDoms.length;i++) {
          let dom = textareaDoms[i];
          dom.removeAttribute('maxlength')
        }
    });
  },
  methods: {

  },
};
</script>

<style lang='scss'></style>